import { render, staticRenderFns } from "./FooterIntro.vue?vue&type=template&id=bc2b2d2e&scoped=true&"
import script from "./FooterIntro.vue?vue&type=script&lang=js&"
export * from "./FooterIntro.vue?vue&type=script&lang=js&"
import style0 from "./FooterIntro.vue?vue&type=style&index=0&id=bc2b2d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2b2d2e",
  null
  
)

/* custom blocks */
import block0 from "@/locales/footer_intro.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FFooter%2FFooterIntro.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports